import React, { Component } from 'react';
import PropTypes from 'prop-types';

export class LiveStreamViewerCount extends Component {
	static propTypes = {
		liveStreamActiveViewerCount: PropTypes.number,
		userActive: PropTypes.bool,
	};

	render() {
		const className = `vjs-live-viewer-count ${this.props.userActive ? 'show-viewer-count' : 'hide-viewer-count'}`;

		return (
			<div className={className}>
				<img alt="viewers-icon" className="live-viewer-show-icon" src="/public/images/show.svg" />
				{this.props.liveStreamActiveViewerCount || 0}
			</div>
		);
	}
}
